import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
    content: {
        paddingHorizontal: 25,
    },
    textInfo: {
        marginTop: 200,
        fontWeight: '700',
        fontSize: 17,
        lineHeight: 20,
        textAlign: 'center'
    },
    contentBtn: {
        position: 'absolute',
        bottom: 60,
        paddingHorizontal: 25,
        width: '100%'
    },
    btn: {
        padding: 10,
        borderRadius: 20
    },
    textBtn: {
        color: '#fff',
        textAlign: 'center',
        fontSize: 18,
        fontWeight: '500'
    },
});

export default styles;
